const selectors = {
    link: '[data-scroll-link]',
  }
  
  
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(selectors.link).forEach(anchor => {
      anchor.addEventListener('click', function (e) {
          e.preventDefault();
          const targetHrefElement = document.querySelector(this.getAttribute('href'))
          if (!!!targetHrefElement) {
            return
          }
          const targetElement = targetHrefElement.offsetTop - 50;
          
          if (!!!targetElement) {
            return
          }
          window.scroll({ top: targetElement, behavior: "smooth" });
      });
    });
  });